import { AccessToken, MGMAuthError } from '@mgmresorts/mgm-auth-js-sdk';
import { isSSR, window } from '@mgmresorts/wcl-utils';

import { actually } from '../logging';
import { retryPromise } from '../retry';

const TOKEN_IFRAME_ID = 'MGM_IDENT_TOKEN_IFRAME' as const;
const TOKENS_KEY = 'MGM_IDENT_TOKENS' as const;
const TOKENS_ERROR_KEY = 'MGM_IDENT_TOKENS_ERROR' as const;

export const createHiddenIframe = (mobileToken: string, iframeId = TOKEN_IFRAME_ID) => {
  actually.debug('[auth]', ' creating iframe');
  const iframe = document.createElement('iframe');
  iframe.setAttribute('id', iframeId);
  iframe.setAttribute('loading', 'eager');
  // iframe.setAttribute('sandbox', 'allow-same-origin');
  iframe.setAttribute(
    'src',
    `${process.env.REACT_APP_MOBILE_SESSION_TRANFER_URL}?fromURI=${window?.location.origin}/identity/auth/login&login_hint=${mobileToken}`,
  );

  if (!process.env.REACT_APP_DEV_MODE) {
    iframe.setAttribute('hidden', 'true');
  }

  document.body.appendChild(iframe);
};

export const destroyIframe = (iframeId = TOKEN_IFRAME_ID) => {
  // we were never here...
  sessionStorage.removeItem(TOKENS_KEY);
  sessionStorage.removeItem(TOKENS_ERROR_KEY);

  const iframe = document.getElementById(iframeId);
  actually.debug('[auth]', ' destroying iframe');
  if (iframe) document.body.removeChild(iframe);
};

export const readErrorFromIframe = (): string | undefined => {
  const error = sessionStorage.getItem(TOKENS_ERROR_KEY);
  if (error) actually.error('[TOKEN ERROR]', error);

  return error ?? undefined;
};

export const readTokenFromIframe = async (): Promise<AccessToken> => {
  const accessToken = JSON.parse(sessionStorage.getItem(TOKENS_KEY) ?? '{}') as AccessToken;
  const tokenError = readErrorFromIframe();

  if (tokenError || !accessToken.value) {
    throw new Error('Failed to acquire tokens after threshold...aborting');
  }

  return accessToken;
};

export const setIframeError = (error: MGMAuthError): void => sessionStorage.setItem(TOKENS_ERROR_KEY, error.message);
export const setIframeToken = (token: AccessToken): void => sessionStorage.setItem(TOKENS_KEY, JSON.stringify(token));

export function isInAuthFrame() {
  return window?.location?.href && window.location.href.includes('/auth/');
}

/**
 *  Returns true if we're running from the iframe or in application compilation, exit
 */
export function isInSSROrAuthFrame() {
  return isSSR() || isInAuthFrame();
}

export const fetchAccessToken = async (mobileToken: string): Promise<AccessToken> => {
  createHiddenIframe(mobileToken);

  try {
    // try for 30 seconds...if we fail after that, we're in trouble
    const token = await retryPromise<AccessToken>(readTokenFromIframe, 60, 500);
    destroyIframe();

    return token;
  } catch (e) {
    // destroyIframe();

    return Promise.reject(e);
  }
};
